import { ref, watch, onMounted } from '@vue/composition-api'
import useRouter from '../useRouter'

const usePagination = () => {
    const {route, router} = useRouter();
    const page = ref(+route.value.query.page || 1)


    const setPage = pageNumber => {
        if(pageNumber){
            router.push({
                query: {
                    ...route.value.query,
                    page: +pageNumber
                }
            }).catch(e => {})
        }
        page.value = +pageNumber
    };

    watch([route], ([newRoute]) => {
        if(!route.value.query.page){
           page.value = 1;
        }
    })

    return {
        page,
        setPage
    }

}

export default usePagination
